import React from "react";
import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

import APIS from "../constant/EndPoint";
import useTenantControlGetHook from "../customHooks/useTenantControlGetHook";
import useGetHook from "../customHooks/useGetHook";
import Spinner from "../components/Reusable/Spinner";
import AdminNotice from "../components/AdminNotice";
import StaffNotice from "../components/StaffNotice";

const PaymentRequiredComponent = loadable(
  () => import("../components/PaymentRequired")
);
const PaymentRequired = () => {
  const { data: profileData, isLoading: isUserProfileloading } = useGetHook({
    url: `${APIS.USER}me/`,
    queryKey: ["user-profile"],
    params: {},
  });
  const { data: ClientData, isLoading: isClientDataLoading } = useGetHook({
    url: `${APIS.CONFIGURATION}`,
    queryKey: ["client-data"],
    params: {},
  });

  const { data, isLoading } = useTenantControlGetHook({
    queryKey: ["subscription"],
    url: APIS.SUBSCRIPTION,
    params: {
      token: localStorage.getItem("token"),
    },
  });
  return (
    <>
      {isLoading || isClientDataLoading || isUserProfileloading ? (
        <Spinner />
      ) : (
        <div className={tw`flex h-[100vh] overflow-y-auto flex-col  `}>
          {profileData?.is_superuser ? (
            <AdminNotice data={data} />
          ) : (
            <StaffNotice ClientData={ClientData} />
          )}
        </div>
      )}
    </>
  );
};

export default PaymentRequired;
